import React, { useEffect } from "react";
import { useArrayContext } from "../../../state/ArrayContext";

interface ConstantArrayProps {
    values: string;
}

/***
 * Array source that returns a constant array of values.
 * 
 * Params:
 *      values: a comma separated list of values to return.
 */
export const ConstantArray = React.memo(function ConstantArray({ values }: ConstantArrayProps): React.ReactElement {
    const { setArray } = useArrayContext();

    useEffect(() => {
        const items = values.split(',').map((value, index) => ({ value, position: index + 1, props: {} }));
        setArray(items);
    }, [values, setArray]);

    return <></>;
});